import { useState } from "react";
import { useDispatch } from "react-redux";
import { setSnackbar } from "@Redux/snackBarSlice";
import axiosInstance from "@API/axios";

/**
 * Used to send a post request to create a new data record.
 * Sending the flag showSnackBar determines whether the function would dispatch snackbars or not.
 */

const useSendPostRequest = (showSnackBar = false) => {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);

  const postData = (
    url,
    data,
    timeoutValue,
    succesMessage = "Request has been sent."
  ) => {
    setIsLoading(true);
    setIsError(false);
    return (
      timeoutValue
        ? axiosInstance.post(url, data, { timeout: timeoutValue })
        : axiosInstance.post(url, data)
    )
      .then((response) => {
        setIsLoading(false);
        setIsError(false);
        if (showSnackBar) {
          dispatch(
            setSnackbar({
              open: true,
              message: succesMessage,
              error: false,
            })
          );
        }
        return response;
      })
      .catch((error) => {
        setIsError(true);
        setIsLoading(false);

        if (showSnackBar) {
          let errorMsg = "Internal Server Error.";
          const data = error?.response?.data;

          if (typeof data === "object" && data?.details) {
            errorMsg = data.details;
          } else if (typeof data === "string") {
            errorMsg = data;
          }

          dispatch(
            setSnackbar({
              open: true,
              message: errorMsg,
              error: true,
            })
          );
        }
      });
  };

  return { requestMethod: postData, isLoading, isError };
};

export default useSendPostRequest;
